var indentation_default = {
  "indentZero": "QMtOy",
  "indentOne": "OBvGv",
  "indentTwo": "BzNGN",
  "indentThree": "kWCDN",
  "indentFour": "YryLs",
  "indentFive": "koRlv",
  "indentSix": "KGmka"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
